import { z } from "zod";

import { FilterFieldConfig } from "@/modules/common/filters";
import {
  MANAGEMENT_COMPANY_STATUS_OPTIONS,
  MANAGEMENT_MODEL_OPTIONS,
  MANAGEMENT_USAGE_TYPE_OPTIONS,
  ManagementCompanyStatus,
  ManagementCompanyUsageType,
  ManagementModel,
} from "@/modules/common/types/ManagementCompanies.enum";
import useManagementCompanyOwners from "@/modules/common/hooks/lists/useManagementCompanyOwners";

export const MANAGEMENT_COMPANY_FILTER_FIELDS: FilterFieldConfig[] = [
  {
    key: "search",
    label: "Pesquisar",
    type: "text",
    placement: "inline",
    schema: z.string(),
  },
  {
    key: "managementModel",
    label: "Modelo de gestão",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(ManagementModel)),
    options: MANAGEMENT_MODEL_OPTIONS,
  },
  {
    key: "status",
    label: "Status",
    type: "select-multiple",
    placement: "both",
    schema: z.array(z.coerce.number().pipe(z.enum(ManagementCompanyStatus))),
    options: MANAGEMENT_COMPANY_STATUS_OPTIONS,
    serialize: (value) => (value?.length ? value.join(",") : undefined),
    deserialize: (raw) => {
      const parsed = z.array(z.coerce.number().pipe(z.enum(ManagementCompanyStatus))).safeParse((raw ?? "").split(",").filter(Boolean));
      return parsed.success && parsed.data.length ? parsed.data : undefined;
    },
  },
  {
    key: "usageType",
    label: "Tipo da Gestora",
    type: "select",
    placement: "both",
    schema: z.coerce.number().pipe(z.enum(ManagementCompanyUsageType)),
    options: MANAGEMENT_USAGE_TYPE_OPTIONS,
  },
  {
    key: "ownerId",
    label: "Representante",
    type: "select-async",
    placement: "both",
    schema: z.string(),
    useOptions: useManagementCompanyOwners,
  },
  {
    key: "createdAt",
    label: "Criado em",
    type: "period",
    placement: "both",
    schema: z.any(),
    inputs: [
      {
        key: "createdAtAfter",
        label: "Criado após",
        type: "date",
        schema: z.string(),
      },
      {
        key: "createdAtBefore",
        label: "Criado até",
        type: "date",
        schema: z.string(),
      },
    ],
  },
];
